// extracted by mini-css-extract-plugin
module.exports = {"link-button":"link-button-module__link-button___1SvTD","linkButton":"link-button-module__link-button___1SvTD"};